<script lang="ts" setup>
    const selfServiceUrlProfession = useSelfServiceUrl('profession');
</script>

<template>
    <div
        class="auth-wrapper"
        data-testid="memory-forbidden-auth-form"
    >
        <img
            src="../../assets/images/404.svg"
            aria-hidden="true"
            alt=""
        />
        <div class="auth-info">
            <h2 class="login-modal-title">Fehlende Berechtigung</h2>

            <p class="login-modal-text">
                Wir haben bemerkt, dass du noch nicht berechtigt bist, am Bonusprogramm teilzunehmen. Bitte ergänze
                <NuxtLink
                    class="sso-link"
                    :to="selfServiceUrlProfession"
                    >hier</NuxtLink
                >
                deine Angaben zur Tätigkeit und beginne, Punkte zu sammeln.
            </p>

            <PrimaryButton
                button-text="Jetzt ergänzen"
                :button-href="selfServiceUrlProfession"
                :has-icon="true"
                size="small"
                :retain-size="true"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/auth-login-form.scss';
</style>
